import type { HTMLAttributes } from 'react';
import React, { forwardRef } from 'react';

import { ChatMessageInput } from './ChatMessageInput';

interface ConversationBottomBarProps extends HTMLAttributes<HTMLDivElement> {
  sendMessage: (message: string) => Promise<void>;
}

export const ConversationBottomBar = forwardRef<
  React.ElementRef<'div'>,
  ConversationBottomBarProps
>((props, ref) => (
  <div
    ref={ref}
    style={{
      padding: '16px 20px',
      borderRadius: '8px',
      position: 'absolute',
      bottom: '50px',
      width: '100%',
      right: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      maxWidth: '400px',
      backgroundColor: 'white'
    }}
  >
    <ChatMessageInput sendMessage={props.sendMessage} />
  </div>
));
